import appManagement from './appManagement/th'
import banner from './banner/th'
import baseData from './baseData/th'
import book from './book/th'
import carManagement from './carManagement/th'
import carMonitor from './carMonitor/th'
import components from './components/th'
import diagnostics from './diagnostics/th'
import excelTemplate from './excelTemplate/th'
import feedback from './feedback/th'
import geofence from './geofence/th'
import home from './home/th'
import login from './login/th'
import map from './map/th'
import navbar from './navbar/th'
import notFound from './notFound/th'
import notice from './notice/th'
import offlineAlarm from './offlineAlarm/th'
import oper from './oper/th'
import overspeedAlarm from './overspeedAlarm/th'
import vehicleAlarm from './vehicleAlarm/th'
import publicModule from './publicModule/th'
import request from './request/th'
import resultDialog from './resultDialog/th'
import shop from './shop/th'
import sms from './sms/th'
import statistical from './statistical/th'
import system from './system/th'
import table from './table/th'
import tagsView from './tagsView/th'
import traffic from './traffic/th'

const message = {
  appManagement,
  banner,
  baseData,
  book,
  carManagement,
  carMonitor,
  components,
  diagnostics,
  excelTemplate,
  feedback,
  geofence,
  home,
  login,
  map,
  navbar,
  notFound,
  notice,
  offlineAlarm,
  oper,
  overspeedAlarm,
  vehicleAlarm,
  public: publicModule,
  request,
  resultDialog,
  shop,
  sms,
  statistical,
  system,
  table,
  tagsView,
  traffic
}

export default message
